import ArticleCard from "../components/ArticleCard"
import '../assets/css/Common.css'
import '../assets/css/Articles.css'
import { forwardRef, useCallback, useContext, useEffect, useState, memo } from "react"
import ArticlesContext from "../context/ArticlesContext"
import { setIsNextButtonDisabled, setIsPreviousButtonDisabled, setReachedFirstPage } from "../context/ArticlesContextActions"
import { Skeleton } from "antd"
import { Helmet } from "react-helmet"
import { ORCID_ROOT } from "../HistoriografijaConstants"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"

const Articles = memo(forwardRef(function (props, ref) {
    const { state, dispatch } = useContext(ArticlesContext)
    const [pagination, setPagination] = useState({})
    const [filterValues, setFilterValues] = useState()

    useEffect(() => {
        setPagination({
            paginatedArticles: props.paginatedArticles,
            totalNumber: props.totalNumber
        })
        setFilterValues(props.filterValues)
    }, [props, setFilterValues, setPagination])

    const scrollToPaginatedArticles = useCallback(() => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [ref])

    const getNextArticles = useCallback(() => {
        dispatch(setReachedFirstPage(false))
        dispatch(setIsPreviousButtonDisabled(false))
        setTimeout(() => scrollToPaginatedArticles(), 100)
        const propsLoadNextArticles = props.loadNextArticles // because of the warning in the dependency array
        propsLoadNextArticles(
            pagination.paginatedArticles[
                pagination.paginatedArticles.length - 1
            ]?.id, 
            filterValues.selectedCategoryId, 
            filterValues.selectedSubCategoryId, 
            filterValues.keyword, 
            filterValues.authorUrl
        )
    }, [dispatch, scrollToPaginatedArticles, props.loadNextArticles, pagination.paginatedArticles, filterValues])

    const getPreviousArticles = useCallback(() => {
        dispatch(setIsNextButtonDisabled(false))
        const propsLoadPrevArticles = props.loadPreviousArticles
        propsLoadPrevArticles(pagination.paginatedArticles[0]?.id, filterValues.selectedCategoryId, filterValues.selectedSubCategoryId, filterValues.keyword, filterValues.authorUrl)
    }, [dispatch, props.loadPreviousArticles, pagination.paginatedArticles, filterValues])

    const getTitle = useCallback(() => {
        return filterValues ? (filterValues.selectedCategory ? (filterValues.selectedSubCategory ? 
                                            <span>
                                                {filterValues.selectedCategory} <FontAwesomeIcon icon={faArrowRight} /> {filterValues.selectedSubCategory}
                                            </span> :
                                            filterValues.selectedCategory) 
                                            : 
                                            filterValues.keyword ? "Pretraga po pojmu " + filterValues.keyword 
                                                                : 
                                                                filterValues.authorName ? filterValues.authorName 
                                                                                        : 
                                                                                        !filterValues.selectedCategory && !filterValues.selectedSubCategory && !filterValues.keyword 
                                                                                        && !filterValues.authorName && "Svi članci")
                            : ""
    }, [filterValues])

    const getTitleForTabName = useCallback(() => {
        return filterValues ? (filterValues.selectedCategory ? (filterValues.selectedSubCategory ? 
                                                filterValues.selectedCategory + ' ' + filterValues.selectedSubCategory :
                                            filterValues.selectedCategory) 
                                            : 
                                            filterValues.keyword ? "Pretraga po pojmu " + filterValues.keyword 
                                                                : 
                                                                filterValues.authorName ? filterValues.authorName 
                                                                                        : 
                                                                                        !filterValues.selectedCategory && !filterValues.selectedSubCategory && !filterValues.keyword 
                                                                                        && !filterValues.authorName && "Svi članci")
                            : ""
    }, [filterValues])

    const title = getTitle()
    const titleForTabName = getTitleForTabName()

    return (
        <div className="flex-container flex-column center-align articles-div" ref={ref}>
            {!state.error && filterValues ? (
                <>
                {!state.loading && 
                    titleForTabName !== "Svi članci" && <Helmet>
                        <title>{"Historiografija.ba | " + titleForTabName}</title>
                    </Helmet>
                }
                {!state.loading ? (filterValues &&
                    <h1 className="top-margin-5 font-weight-400 title-font-size">
                        {title}
                    </h1>)
                    :
                    <div className="flex-container width-45p">
                        <Skeleton active paragraph={{rows: 0}} title={{width: '100%'}}/>
                    </div>
                }
                {
                    filterValues.authorName && props.authorOrcid && 
                    <a target="_blank" rel='noreferrer' href={ORCID_ROOT + props.authorOrcid}>{ORCID_ROOT + props.authorOrcid}</a>
                }
                {!state.loading && !props.loading ? (pagination.paginatedArticles && pagination.paginatedArticles.length !== 0 && 
                        <div className="flex-container flex-wrap top-margin-5 start-content-align center-justify height-100p full-width">
                                {pagination.paginatedArticles.map((article) => {
                                    return <ArticleCard
                                        key={article.id}
                                        articleId={article.id}
                                        title={article.title}
                                        image={article.image}
                                        categoryName={article.categoryName}
                                        date={article.date}
                                        url={article.url}
                                    />
                                })}
                        </div>)
                    :
                    <div className="flex-container flex-wrap top-margin-5 start-content-align center-justify height-100p full-width">
                        {[...Array(12)].map((e, i) => (
                            <div className="flex-container flex-column flex-wrap article-grid-item" key={i}>
                                <Skeleton active paragraph={{rows: 0}} title={{width: '100%'}} />
                            </div>
                        ))}
                    </div>
                }
                {!state.loading && (pagination.totalNumber === 0 ? <p>Nema rezultata.</p> :
                    <div className="flex-container pagination-container">
                        {state.reachedFirstPage && !state.isNextButtonDisabled && <p className="info-about-end">Stigli ste na početak.</p>}
                        {(!state.isPreviousButtonDisabled || !state.isNextButtonDisabled) && <div>
                            <button onClick={getPreviousArticles} className="pagination-button pagination-button-left" disabled={state.isPreviousButtonDisabled}>
                                Prethodna
                            </button>
                            <button onClick={getNextArticles} className="pagination-button pagination-button-right" disabled={state.isNextButtonDisabled}>
                                Sljedeća
                            </button>
                        </div>}
                        {state.isNextButtonDisabled && <p className="info-about-end">Stigli ste do kraja.</p>}
                    </div>)
                }
                </>
                )
                :
                (
                    <div className="flex-container flex-wrap top-margin-5 center-justify full-width">
                        {[...Array(3)].map((_, i) => (
                            <div key={i} className="card" style={{ visibility: 'hidden' }}></div>
                        ))}
                    </div>
                )
            }
        </div>
    )
}))

export default Articles